import React, { useEffect }  from 'react'
import { Box } from '@mui/material'
import OrderModification from './OrderModification'
import RecordDeletion from './RecordsDeletion'
import { useDispatch } from "react-redux";
import {
  reset
} from "../centralAdminSlice";

export default function RecordModification() {
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(reset("OnRefresh"));
  }, []);
  
  return (
    <Box>
      <RecordDeletion/>
		  <OrderModification/>
    </Box>
  )
}
